// Odpočítávadlo do nejbližšího koncertu.
// Vrací HTML a funkci mount(), která spustí tikání každou vteřinu.

export function createCountdown(targetIso) {
    const html = `
        <div class="countdown" data-target="${targetIso}">
            <div class="cd-unit"><span class="cd-num" data-u="d">–</span><span class="cd-lbl">dní</span></div>
            <div class="cd-sep">:</div>
            <div class="cd-unit"><span class="cd-num" data-u="h">–</span><span class="cd-lbl">hodin</span></div>
            <div class="cd-sep">:</div>
            <div class="cd-unit"><span class="cd-num" data-u="m">–</span><span class="cd-lbl">minut</span></div>
            <div class="cd-sep">:</div>
            <div class="cd-unit"><span class="cd-num" data-u="s">–</span><span class="cd-lbl">vteřin</span></div>
        </div>
    `;

    function mount(root) {
        const el = root.querySelector('.countdown');
        if (!el) return;
        const target = new Date(targetIso).getTime();
        const cells = {
            d: el.querySelector('[data-u="d"]'),
            h: el.querySelector('[data-u="h"]'),
            m: el.querySelector('[data-u="m"]'),
            s: el.querySelector('[data-u="s"]')
        };

        function tick() {
            let diff = Math.floor((target - Date.now()) / 1000);
            if (diff < 0) diff = 0;
            const d = Math.floor(diff / 86400);
            const h = Math.floor((diff % 86400) / 3600);
            const m = Math.floor((diff % 3600) / 60);
            const s = diff % 60;
            cells.d.textContent = d;
            cells.h.textContent = String(h).padStart(2, '0');
            cells.m.textContent = String(m).padStart(2, '0');
            cells.s.textContent = String(s).padStart(2, '0');
            if (diff === 0) { clearInterval(timer); el.classList.add('is-live'); }
        }

        tick();
        const timer = setInterval(tick, 1000);
        // Vyčistí se při příští výměně view (router vyprázdní kontejner).
        return () => clearInterval(timer);
    }

    return { html, mount };
}
